
export default {
  name: 'FcFooter',
  components: {
    FooterLinkLists: () => import(/* webpackChunkName: "FooterLinkLists" */ './FooterLinkLists'),
    FooterNavigation: () => import(/* webpackChunkName: "FooterNavigation" */ './FooterNavigation'),
    FooterBottom: () => import(/* webpackChunkName: "FooterBottom" */ './FooterBottom')
  }
}
